import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import * as AuthSelectors from '../store/auth.selectors';
import * as AuthActions from '../store/auth.actions';
import { User } from '../model/auth.interfaces';
import { Store } from '@ngrx/store';

@Injectable({ providedIn: 'root' })
export class AuthStoreService {
  private store = inject(Store);

  private userSubject = new BehaviorSubject<User | null>(null);
  private isAuthenticatedSubject = new BehaviorSubject<boolean>(false);

  constructor() {
    this.store.select(AuthSelectors.selectUser).subscribe((user) => {
      this.userSubject.next(user);
    });

    this.store.select(AuthSelectors.selectIsAuthenticated).subscribe((isAuth) => {
      this.isAuthenticatedSubject.next(isAuth);
    });
  }

  setUser(user: User | null) {
    if (user) {
      this.store.dispatch(AuthActions.setUser({ user }));
    } else {
      this.store.dispatch(AuthActions.logoutSuccess());
    }
  }

  getUser(): Observable<User | null> {
    return this.store.select(AuthSelectors.selectUser);
  }

  getUserValue(): User | null {
    return this.userSubject.getValue();
  }

  isAuthenticated(): Observable<boolean> {
    return this.store.select(AuthSelectors.selectIsAuthenticated);
  }

  isAuthenticatedValue(): boolean {
    return this.isAuthenticatedSubject.getValue();
  }

  clear(): void {
    this.store.dispatch(AuthActions.logoutSuccess());
  }

  login(email: string, password: string): void {
    this.store.dispatch(
      AuthActions.login({
        credentials: { email, password },
      }),
    );
  }

  logout(): void {
    this.store.dispatch(AuthActions.logout());
  }

  checkAuthState(): void {
    this.store.dispatch(AuthActions.checkAuth());
  }
}
